export const ABOUTE_ROUTE = "/aboute_us"
export const ABOUTE_ROUTE_RU = "/ru/aboute_us"
export const CONTACTS_ROUTE = "/contacts"
export const CONTACTS_ROUTE_RU = "/ru/contacts"
